import React from 'react';
import { Box, Grid } from '@mui/material';
import config from 'config/config';
import { GallerySection } from 'Pages/Main/cmsTypes';

interface GalleryProps {
  section: GallerySection;
}

const Gallery = ({ section }: GalleryProps) => {
  if (!section || !section.gallery) return null;

  const { gallery } = section;

  return (
    <Box sx={{ py: 4 }}>
      <Grid
        container
        spacing={4}
        justifyContent={gallery.length <= 2 ? 'center' : 'flex-start'}
      >
        {gallery.map((image, index) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={image.documentId || index}>
            <Box
              component="img"
              src={`${config.CMS_BASE_URL}${
                image.formats?.large?.url ||
                image.formats?.medium?.url ||
                image.formats?.small?.url ||
                image.url
              }`}
              alt={image.alternativeText}
              sx={{
                width: '100%',
                height: 500,
                objectFit: 'cover',
                borderRadius: 2,
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Gallery;
